/* eslint-env es6 */

import fuzzaldrin from 'fuzzaldrin-plus';
import * as re from './re.es6';

export function inherit (obj, properties) {
    function F () {}
    F.prototype = obj.prototype;
    return $.extend(new F(), properties);
}

export function arrayFrom (input) {
    return Array.from(input);
}

export function stringSlice (str, beginIndex, endIndex) {
    return Array.from(str).slice(beginIndex, endIndex).join(''); 
}

export function hasKey (objList, key) {
    return objList.some(function (obj) {
        return Object.prototype.hasOwnProperty.call(obj, key);
    });
}

export function ts () {
    return new Date().getTime();
}

export function highlightTerm (string, term, replacement) {
    replacement = replacement || "<strong>$1</strong>";
    if (term) {
        return string.replace(new RegExp(
            "(?![^&;]+;)(?!<[^<>]*)(" +
            re.escape(term) +
            ")(?![^<>]*>)(?![^&;]+;)", "gi"
        ), replacement);
    } else {
        return string;
    }
}

export function stringify (value) {
    if (_.isString(value)) {
        return value;
    }
    return (value || value === 0) ? String(value) : '';
}

export function containsEqual (list, value) {
    return !!_.find(list, function (v) {
        return _.isEqual(value, v);
    });
}

export function lengthInUtf8Bytes (str) {
    // https://gist.github.com/mathiasbynens/1010324
    try {
        return ~-encodeURI(str).split(/%..|./).length;
    } catch (exc) {
        // Fallback if they're sending us invalid utf8
        return str.length;
    }
}

export function truncate (str, length) {
    let lines = str.split(/[,\r\n]/);
    let first = lines[0];
    if (first.length <= length + 3) {
        if (lines.length > 1) {
            first += '…';
        }
        return first;
    }
    return first.slice(0, length) + '…';
}

export function strHex (string) {
    return _.map(string, function (chr) {
        var code = chr.charCodeAt(0);
        if (code < 32) {
            var hex = code.toString(16);
            return '\\u' + '0000'.substr(hex.length) + hex;
        } else {
            return chr;
        }
    }).join('');
}

export function naturalCompare(a, b) {
    // https://github.com/litejs/natural-compare-lite
    if (a != b) for (var i, ca, cb = 1, ia = 0, ib = 0; cb;) {
        ca = a.codePointAt(ia++) || 0;
        cb = b.codePointAt(ib++) || 0;

        if (ca < 58 && ca > 47 && cb < 58 && cb > 47) {
            for (i = ia; ca = a.codePointAt(ia), ca < 58 && ca > 47; ia++);
            ca = (a.slice(i - 1, ia) | 0) + 1;
            for (i = ib; cb = b.codePointAt(ib), cb < 58 && cb > 47; ib++);
            cb = (b.slice(i - 1, ib) | 0) + 1;
            if (ca != cb) return (ca < cb) ? -1 : 1;
        } else if (ca != cb) {
            return String.fromCodePoint(ca).localeCompare(String.fromCodePoint(cb));
        }

        if (ca != cb) return String.fromCodePoint(ca).localeCompare(String.fromCodePoint(cb));
    }
    return 0;
}

function getSharedBufferParts (bufferId) {
    if (!bufferId) {
        return null;
    }
    if (bufferId.indexOf(' ') !== -1) {
        return null;
    }
    
    bufferId = bufferId.replace(/^!\//, '');

    var parts = {
        connectionId: ''
    };

    var protocolParts = bufferId.split('://');
    var bufferParts = protocolParts.pop().split('/');
    if (protocolParts[0] === 'ircs') {
        parts.ssl = true;
        parts.connectionId += 'ircs://';
    }
    var hostPortPart = bufferParts.shift();
    var connectionParts = hostPortPart.split(':');
    parts.hostname = decodeURIComponent(connectionParts[0]);
    // Max FQDN is 255, max protocol is 63
    if (parts.hostname.length > 255) {
        parts.hostname = '';
    }
    parts.connectionId += parts.hostname;
    if (parts.hostname && connectionParts[1]) {
        parts.port = decodeURIComponent(connectionParts[1]);
        // Max port is unsigned 16 bit int
        if (parts.port > 65535) {
            delete parts.port;
        } else {
            parts.connectionId += ':' + parts.port;
        }
    }
    // Arbitrary disambiguation limit, use same as port
    if (parts.port && connectionParts[2] && connectionParts[2] <= 65535) {
        parts.disambiguation = connectionParts[2];
    }

    if (parts.disambiguation) {
        parts.connectionId += ':' + parts.disambiguation;
    }
    parts.bufferParts = bufferParts;
    return parts;
}

export function getBufferPartsLegacy (bufferId, hash) {
    var parts = getSharedBufferParts(bufferId);
    if (!parts) {
        return parts;
    }
    var bufferParts = parts.bufferParts;
    delete parts.bufferParts;

    if (!bufferParts[0] && hash) {
        bufferParts[0] = encodeURIComponent('#') + hash;
    }
    if (parts.connectionId && bufferParts[0]) {
        // Limit to first comma delimited value
        parts.buffer = decodeURIComponent(bufferParts[0]).split(',')[0];
        // RFC says max length is 200 or 50, most servers use 32, add a bit of leeway
        if (parts.buffer.length > 255) {
            delete parts.buffer;
        }
    }
    return parts;
}

export function getBufferParts (bufferId) {
    var parts = getSharedBufferParts(bufferId);
    if (!parts) {
        return parts;
    }
    var bufferParts = parts.bufferParts;
    delete parts.bufferParts;

    if (parts.connectionId && bufferParts[0]) {
        // Limit to first comma delimited value
        if (!bufferParts[1]) {
            return parts;
        }
        var bufferName = decodeURIComponent(bufferParts[1]).split(',')[0];
        if (bufferParts[0] == 'channel') {
            parts.type = 'channel';
            parts.buffer = bufferName;
        } else if (bufferParts[0] == 'messages') {
            parts.type = 'conversation';
            parts.buffer = bufferName;
        } else if (bufferParts[0] == 'thread') {
            parts.thread = decodeURIComponent(bufferParts[1]);
        }
        // RFC says max length is 200 or 50, most servers use 32, add a bit of leeway
        if (parts.buffer && parts.buffer.length > 255) {
            delete parts.buffer;
        }

        if (!parts.thread && bufferParts[2] == 'thread') {
            parts.thread = decodeURIComponent(bufferParts[3]);
        }
    }
    return parts;
}

export function ircUrlParts (ircUrl) {
    // http://tools.ietf.org/html/draft-butcher-irc-url-04
    if (!ircUrl) {
        return;
    }
    var urlParts = ircUrl.match(/(ircs?):\/{0,2}(.*)/i);
    if (!urlParts || !urlParts[2]) {
        return;
    }
    var protocol = urlParts[1];
    var rest = urlParts[2];
    var bufferParts = rest.split('#');
    var rootPart, bufferString;
    if (bufferParts[0].indexOf('/') === -1) {
        // No slash used as channel delimiter, just hash
        rootPart = bufferParts.shift();
        if (bufferParts.length) {
            bufferString = '#' + bufferParts.join('#');
        }
    } else {
        bufferParts = rest.split('/');
        rootPart = bufferParts.shift();
        if (bufferParts.length) {
            bufferString = bufferParts.join('/');
        }
    }

    // Convert +6697 to ircs port
    var user, pass;
    var userHostSplit = rootPart.split('@');
    if (userHostSplit[1]) {
        rootPart = userHostSplit[1];
        var userPassSplit = userHostSplit[0].split(':');
        user = userPassSplit[0];
        pass = userPassSplit[1];
    } else {
        rootPart = userHostSplit[0];
    }
    var rootPartSplit = rootPart.split(':');
    if (rootPartSplit[1]) {
        var rootPortSSL = rootPartSplit[1].match(/^\+(\d+)$/);
        if (rootPortSSL) {
            protocol = 'ircs';
            rootPart = rootPartSplit[0] + ':' + rootPortSSL[1];
        }
    }
    if (protocol && protocol.toLowerCase() === 'ircs') {
        rootPart = 'ircs://' + rootPart;
    }
    
    var url = rootPart;
    var label;
    var type = 'network';
    var query;
    if (bufferString) {
        var bufferQueryParts = bufferString.split('?');
        query = bufferQueryParts[1];
        var bufferStringParts = bufferQueryParts[0].split(',');
        label = decodeURIComponent(bufferStringParts[0]);
        var isNick = bufferStringParts[1] == 'isuser' || bufferStringParts[1] == 'isnick';
        if (isNick) {
            type = 'user';
        } else {
            type = 'channel';
        }
        if (!isNick && $.inArray(label[0], ['#', '＃', '&', '+', '!']) == -1) {
            label = '#' + label;
        }
        url += '/' + encodeURIComponent(label);
    }
    return {
        root: rootPart,
        user: user,
        pass: pass,
        query: query,
        label: label,
        url: url,
        type: type
    };
}

function makeChan (chan) {
    if (!chan) {
        return;
    }
    if (chan.indexOf('#') !== 0) {
        chan = '#' + chan;
    }
    return chan;
}
let prefix_regexes = {};
export function normaliseChan (chan, prefixes) {
    if (!chan) {
        return;
    }
    prefixes = prefixes || '#';
    if (!prefix_regexes[prefixes]) {
        prefix_regexes[prefixes] = new RegExp("^[" + re.escape(prefixes) + "]+");
    }

    return chan.toLowerCase().replace(prefix_regexes[prefixes], '');
}
export function parseChannels (channels, noPasswords) {
    if (_.isArray(channels)) {
        return channels;
    } else {
        return _.uniq(_.filter(_.flatten(_.map(stringify(channels).trim().split(/[,\r\n]/), function (chan) {
            var chanParts = stringify(chan).trim().split(' ');
            if (!noPasswords && chanParts.length > 0 && chanParts.length <= 2) {
                var result = makeChan(chanParts[0]);
                if (!result) {
                    return;
                }
                if (chanParts[1]) {
                    result += ' ' + chanParts[1];
                }
                return result;
            } else if (noPasswords || chanParts.length > 2) {
                return _.map(chanParts, makeChan);
            }
        })), _.identity));
    }
}

export function slugify (value) {
    return value.toLowerCase().replace(/[^a-z0-9_ ]+/g, '').replace(/ /g, '-');
}

export function capitalize (value) {
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
}


export function matchEmoji (input) {
    var candidates = null;
    if (input.length) {
        candidates = [];
        var found = {};
        emoji.map.colons.each(function searchInputColons (colon, idx) {
            if (!found[idx]) {
                var score = fuzzaldrin.score(colon, input);
                if (colon.indexOf('flag-') === 0) {
                    score = Math.max(score, fuzzaldrin.score(colon.substr(5), input));
                }
                if (score > 0.05) {
                    candidates.push({
                        score: score,
                        idx: idx,
                        colon: colon
                    });
                    found[idx] = true;
                }
            }
        });
        candidates.sort(function (a, b) {
            return b.score - a.score;
        });
    }
    return candidates;
}

export function openPopup (url, title, options = {}) {
    let w = 1024 || options.w;
    let h = 900 || options.h;

    // Fixes dual-screen position                         Most browsers      Firefox
    let dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
    let dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;

    let width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    let height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

    let left = ((width / 2) - (w / 2)) + dualScreenLeft;
    let top = ((height / 2) - (h / 2)) + dualScreenTop;

    let specs = 'width=' + w + ',height=' + h + ',top=' + top + ',left=' + left + '';
    let newWindow = window.open(url, 'popup:' + title, specs);

    let closeWatcher = setInterval(() => {
        if (newWindow.closed) {
            clearInterval(closeWatcher);
            if (options.closeCallback) {
                options.closeCallback();
            }
        }
    }, 500);

    // Puts focus on the newWindow
    if (window.focus) {
        newWindow.focus();
    }

    return [newWindow, closeWatcher];
}


// WEBPACK FOOTER //
// ./app/src/lib/util.es6